import type { TranslationDictionary } from "../types";

export const ptBR = {
    common: {
        save: "Salvar",
        saving: "Salvando...",
        saved: "Salvo",
        cancel: "Cancelar",
        delete: "Excluir",
        actions: "Ações",
        signOut: "Sair",
        email: "E-mail",
        password: "Senha",
        name: "Nome",
        organisation: "Organização",
        optional: "(opcional)",
        upload: "Enviar",
        uploading: "Enviando…",
        create: "Criar",
        close: "Fechar",
        search: "Pesquisar",
        loading: "Carregando...",
        rename: "Renomear",
        share: "Compartilhar",
        errorTryAgain: "Ocorreu um erro. Por favor, tente novamente.",
        assistant: "Assistente",
        edit: "Editar",
        confirm: "Confirmar",
    },

    sidebar: {
        assistant: "Assistente",
        projects: "Projetos",
        tabularReview: "Revisão Tabular",
        laura: "LAURA",
        workflows: "Fluxos de trabalho",
        accountSettings: "Configurações da conta",
        assistantHistory: "Histórico do assistente",
        noChatsYet: "Nenhuma conversa ainda",
        openSidebar: "Abrir barra lateral",
        closeSidebar: "Fechar barra lateral",
    },

    projects: {
        title: "Projetos",
        searchPlaceholder: "Pesquisar projetos…",
        tabAll: "Todos",
        tabMine: "Meus",
        tabSharedWithMe: "Compartilhados comigo",
        colName: "Nome",
        colCm: "CM",
        colFiles: "Arquivos",
        colChats: "Conversas",
        colTabularReviews: "Revisões tabulares",
        colCreated: "Criado em",
        emptyDescription:
            "Envie documentos para projetos para iniciar conversas e revisões tabulares.",
        createNew: "+ Criar novo",
        couldNotLoad: "Não foi possível carregar os projetos.",
        noTabProjects: "Nenhum projeto {tab}",
        newProjectTitle: "Projetos › Novo projeto",
        projectName: "Nome do projeto",
        addCmNumber: "Adicionar número CM...",
        selectProject: "Selecionar projeto…",
        noProjectsFound: "Nenhum projeto encontrado",
    },

    assistant: {
        greeting: "Olá, {username}",
        disclaimer:
            "A IA pode cometer erros. As respostas não constituem assessoria jurídica.",
    },

    account: {
        profileTitle: "Perfil",
        displayName: "Nome de exibição",
        displayNamePlaceholder: "Digite seu nome",
        organisationLabel: "Organização",
        organisationPlaceholder: "Digite sua organização",
        emailLabel: "E-mail",
        usagePlanTitle: "Plano de uso",
        actionsTitle: "Ações",
        dangerZoneTitle: "Zona de perigo",
        dangerZoneDesc:
            "Excluir permanentemente sua conta e todos os dados associados. Esta ação não pode ser desfeita.",
        deleteAccount: "Excluir conta",
        confirmDeleteQuestion:
            "Tem certeza? Isso excluirá permanentemente sua conta.",
        deleting: "Excluindo…",
        languageTitle: "Idioma",
        languageLabel: "Idioma de exibição",
        modelsTitle: "Modelos",
    },

    auth: {
        logInTitle: "Entrar",
        logIn: "Entrar",
        signUp: "Cadastrar-se",
        createAccountTitle: "Criar conta",
        emailPlaceholder: "Digite seu e-mail",
        passwordLabel: "Senha",
        passwordPlaceholder: "Digite sua senha",
        createPasswordPlaceholder: "Crie uma senha (mín. 6 caracteres)",
        confirmPasswordLabel: "Confirmar senha",
        confirmPasswordPlaceholder: "Confirme sua senha",
        namePlaceholder: "Seu nome",
        organisationPlaceholder: "Sua organização",
        passwordsMustMatch: "As senhas não coincidem",
        passwordTooShort: "A senha deve ter pelo menos 6 caracteres",
        accountCreatedTitle: "Conta criada!",
        accountCreatedRedirecting: "Redirecionando para a página inicial...",
        loggingIn: "Entrando...",
        creatingAccount: "Criando conta...",
        demoDisclaimer:
            "O Mike em AuditFlow.com é atualmente um serviço de demonstração. Por favor, não envie, submeta ou armazene documentos sensíveis, confidenciais, privilegiados, de clientes ou com dados pessoais identificáveis.",
        termsPrefix: "Ao se cadastrar, você concorda com nossos",
        termsLink: "Termos de Uso",
        privacyLink: "Política de Privacidade",
        termsConjunction: "e",
    },

    modals: {
        deleteChatsTitle: "Excluir todas as conversas",
        deleteChatsConfirm:
            "Tem certeza de que deseja excluir {count} {chatWord}? Esta ação é permanente e não pode ser desfeita.",
        deleteChatsButton: "Excluir todas as conversas",
        deletingChats: "Excluindo...",
        allChatsDeletedTitle: "Conversas excluídas",
        allChatsDeletedDesc:
            "Seu histórico de conversas foi excluído com sucesso.",
        chat_one: "conversa",
        chat_other: "conversas",
        ownerOnlyTitle: "Apenas para proprietários",
        ownerOnlyDesc:
            "Você só pode {action}. Entre em contato com o proprietário do projeto para obter acesso.",
        dismiss: "Fechar",
        apiKeyMissingTitle: "Chave de API necessária",
        copyLink: "Copiar link",
        linkCopied: "Copiado!",
        shareLink: "Compartilhar link",
        creditsTitle: "Limite de mensagens atingido",
        creditsBody: "Você atingiu seu limite mensal de 100 mensagens.",
        creditsReset: "Seus créditos serão redefinidos em:",
        creditsInfo: "Seus créditos de mensagem são redefinidos automaticamente no primeiro dia de cada mês.",
    },

    tabular: {
        newReviewPlaceholder: "Nome da revisão",
        workflowTemplate: "Modelo de fluxo de trabalho",
        loadingTemplates: "Carregando modelos…",
        noTemplate: "Sem modelo — começar do zero",
        createUnderProject: "Criar em um projeto",
        selectDocuments: "Selecionar documentos",
        projectDocuments: "Documentos do projeto",
        documents: "Documentos",
        noReadyDocs: "Nenhum documento pronto neste projeto",
        noDocs: "Nenhum documento ainda",
        tabularReviews: "Revisões tabulares",
        newReview: "Nova revisão",
        generate: "Gerar",
        generating: "Gerando…",
        addColumn: "+ Adicionar coluna",
        addDocuments: "+ Adicionar documentos",
        clearAll: "Limpar tudo",
        exportExcel: "Exportar para Excel",
        flag: "Indicador",
        results: "Resultados",
        reasoning: "Raciocínio",
        regenerate: "Regenerar",
        columnName: "Nome da coluna",
        columnPrompt: "Instrução",
        columnFormat: "Formato",
        saveColumn: "Salvar",
        deleteColumn: "Excluir coluna",
        noColumns: "Nenhuma coluna ainda",
        noDocuments: "Sem documentos",
        statusPending: "Pendente",
        statusGenerating: "Gerando",
        statusDone: "Concluído",
        statusError: "Erro",
        run: "Executar",
        running: "Executando…",
        export: "Exportar",
        assistantInTabular: "Assistente na revisão tabular",
        clearResults: "Limpar resultados",
        addColumns: "Adicionar colunas",
        columnsSelected: "{count} colunas selecionadas",
        runColumn: "Executar coluna",
        runSelectedColumnsHint: "Executar colunas selecionadas em todos os documentos (ou linhas selecionadas)",
        runSelectedRowsHint: "Executar todas as colunas pendentes nos documentos selecionados",
        searchDocuments: "Pesquisar documentos…",
        untitledReview: "Revisão sem título",
        tabularReview: "Revisão tabular",
        editColumn: "Editar coluna",
        newColumn: "Nova coluna",
        noPreset: "Sem modelo",
        tags: "Etiquetas",
        addTag: "Adicionar etiqueta…",
        addTagHint: "Pressione Enter ou vírgula para adicionar uma etiqueta.",
        autoGeneratePrompt: "Gerar instrução automaticamente",
        columnPromptPlaceholder: "Escreva a instrução de análise — descreva o que o AuditFlow deve extrair de cada documento para esta coluna…",
        addAnotherColumn: "Adicionar outra coluna",
        saveChanges: "Salvar alterações",
        thinking: "Pensando…",
        pondering: "Refletindo…",
        analyzing: "Analisando…",
        reasoningVerb: "Raciocinando…",
        thoughtProcess: "Processo de raciocínio",
        reading: "Lendo",
        read: "Lido",
        chatPlaceholder: "Faça uma pergunta sobre seus documentos...",
        chatHistory: "Histórico de chat",
        newChat: "Novo chat",
        deleteChat: "Excluir chat",
        askQuestion: "Faça uma pergunta sobre esta revisão tabular.",
        searchChats: "Pesquisar chats…",
        noPreviousChats: "Sem chats anteriores.",
        noMatches: "Sem resultados.",
        chatFallback: "Chat",
    },

    workflows: {
        title: "Fluxos de trabalho",
        searchPlaceholder: "Pesquisar fluxos de trabalho…",
        tabAll: "Todos os fluxos",
        tabBuiltin: "Integrados",
        tabCustom: "Personalizados",
        tabHidden: "Ocultos",
        newWorkflow: "Novo fluxo de trabalho",
        importWorkflows: "Importar",
        colName: "Nome",
        colType: "Tipo",
        colCreator: "Criador",
        typeAssistant: "Assistente",
        typeTabular: "Tabular",
        builtIn: "Integrado",
        noWorkflows: "Nenhum fluxo de trabalho encontrado",
        workflowName: "Nome do fluxo de trabalho",
        workflowPrompt: "Instrução do sistema",
        practiceArea: "Área de atuação",
        allPractices: "Todas",
        allTypes: "Todos os tipos",
        hide: "Ocultar",
        unhide: "Mostrar",
        colPractice: "Área",
        colSource: "Fonte",
        filterByType: "Filtrar por tipo",
        filterByPractice: "Filtrar por prática",
        customWorkflowsTitle: "Fluxos personalizados",
        customWorkflowsDesc: "Crie instruções reutilizáveis e modelos de revisão tabular adaptados à sua área de atuação.",
        hiddenWorkflowsTitle: "Fluxos ocultos",
        hiddenWorkflowsDesc: "Os fluxos integrados que você ocultou aparecerão aqui. Você pode mostrá-los a qualquer momento.",
        emptyDesc: "Automatize a análise de documentos com instruções reutilizáveis e modelos de revisão tabular.",
        myCreation: "Eu mesmo",
        sharedFallback: "Compartilhado",
        importTitle: "Importar fluxos de JSON",
        editWorkflow: "Editar fluxo",
        practiceAreaPlaceholder: "Digite a área de atuação…",
        creating: "Criando…",
        saving: "Salvando…",
        createWorkflow: "Criar fluxo de trabalho",
        selectWorkflow: "Selecionar fluxo",
        newChatBreadcrumb: "Novo chat",
        newReviewBreadcrumb: "Nova revisão",
        viewPage: "Ver página",
        edit: "Editar",
        use: "Usar",
        additionalMessage: "Mensagem (opcional)",
        additionalMessagePlaceholder: "Adicione instruções complementares à instrução do fluxo…",
        createInProject: "Criar em um projeto",
        selectProjectLabel: "Selecionar projeto",
        selectDocumentsLabel: "Selecionar documentos",
        noMatchesFound: "Nenhum resultado encontrado",
        noDocsInProject: "Nenhum documento neste projeto",
        selectedCount: "{count} selecionados",
        startingChat: "Iniciando…",
        startChat: "Iniciar chat",
        createReview: "Criar revisão",
        workflowPromptLabel: "Instrução do fluxo",
        columnsLabel: "Colunas",
        noColumnsDefined: "Nenhuma coluna definida",
    },

    shared: {
        addDocuments: "Adicionar documentos",
        uploadFiles: "Enviar arquivos",
        noDocumentsAvailable: "Nenhum documento disponível",
        people: "Pessoas",
        shareWith: "Compartilhar com",
        addByEmail: "Adicionar por e-mail…",
        owner: "Proprietário",
        viewer: "Visualizador",
        removeAccess: "Remover acesso",
        versionUploadTitle: "Enviar nova versão",
        versionFile: "Arquivo",
        versionNote: "Nota de versão",
        versionNotePlaceholder: "O que mudou nesta versão?",
        uploading: "Enviando…",
        uploadVersion: "Enviar versão",
        peopleWithAccess: "Pessoas com acesso",
        noOneHasAccess: "Ninguém tem acesso ainda.",
        remove: "Remover",
        versionNameLabel: "Nome da nova versão",
        versionCurrentLabel: "Versão atual",
        versionNewFileLabel: "Arquivo da nova versão",
        changeFile: "Alterar arquivo",
        newSubfolder: "Nova subpasta",
        download: "Baixar",
        showAllVersions: "Mostrar todas as versões",
        uploadNewVersion: "Enviar nova versão",
        removeFromFolder: "Remover da subpasta",
        editCmNumber: "Editar N.º CM",
    },

    laura: {
        title: "Auditorias LAURA",
        newAudit: "Nova auditoria",
        empty: "Nenhuma auditoria ainda. Crie uma para iniciar o ciclo P0–E8.",
        projectRequired: "Abra um projeto para criar uma auditoria LAURA.",
        p0Title: "P0 — Contextualização do Caso",
        p0Phase: "Fase",
        p0PhasePlanning: "PLANEJAMENTO",
        p0Step: "Etapa",
        p0Progress: "Progresso",
        p0Deliverable: "Entregável",
        p0DeliverablePending: "Briefing Inicial pendente",
        p0DeliverableDone: "Briefing Inicial",
        p0ContextTitle: "Contexto inicial",
        p0SelectDocs: "Documentos do projeto",
        p0SelectDocsHint: "Selecione ao menos um documento para gerar as perguntas.",
        p0InitialComments: "Comentários iniciais (opcional)",
        p0InitialCommentsPlaceholder:
            "Descreva o caso, motivação da auditoria, hipóteses…",
        p0LinkedDocs: "Documentos vinculados",
        p0GenerateQuestions: "Gerar perguntas",
        p0GenerateBriefing: "Gerar briefing inicial",
        p0Generating: "Gerando…",
        p0QuestionsTitle: "Perguntas de esclarecimento",
        p0QuestionsEmpty: 'Clique em "Gerar perguntas" após vincular documentos.',
        p0BriefingTitle: "Briefing Inicial do Caso",
        p0BriefingEmpty:
            'Preencha todas as respostas e clique em "Gerar briefing inicial".',
        p0ValidationTitle: "Pontos de validação antes de avançar para P1",
        p0ValidationEmpty: "Os pontos aparecerão após gerar o briefing.",
        p0WaitingAnswer: "Aguardando…",
        p0CategoryObjeto: "Objeto e contexto",
        p0CategoryEscopo: "Tipo e escopo",
        p0CategoryProblema: "Problema e objetivos",
        p0CategoryRecursos: "Recursos e restrições",
        p0CategoryComplementar: "Informações complementares",
        p0InvalidateTitle: "Alterar contexto?",
        p0InvalidateMessage:
            "Isso invalidará perguntas, respostas e o briefing gerados. Deseja continuar?",
        p0InvalidateConfirm: "Continuar",
        p0InvalidateCancel: "Cancelar",
        p0ChatHint:
            "Use o chat para tirar dúvidas ou pedir ajustes em seções do briefing. As perguntas de esclarecimento são preenchidas apenas no formulário.",
        p0ChatEmpty:
            "Quero iniciar uma auditoria: vincule documentos do projeto, opcionalmente adicione comentários e clique em Gerar perguntas.",
        p0ApprovedAt: "Aprovado em {date} por {user}",
        p0SaveComments: "Salvar comentários",
        p0WorkflowTitle: "Fluxo do P0 — siga estas etapas em ordem",
        p0Step1Help: "Selecione os documentos relevantes do projeto em Contexto inicial.",
        p0Step2Help: "Opcional: adicione comentários iniciais sobre o caso.",
        p0Step3Help: "Salve os comentários (ou salve ao sair do campo).",
        p0Step4Help: "Clique em Gerar perguntas.",
        p0Step5Help: "Responda todas as perguntas de esclarecimento no painel à esquerda.",
        p0Step6Help: "Clique em Gerar briefing inicial e revise ou edite o texto.",
        p0Step7Help:
            "Marque todos os pontos de validação e depois Aprovar e avançar no rodapé.",
        p0ContextExpand: "Mostrar contexto inicial",
        p0ContextCollapse: "Ocultar contexto inicial",
        p0ContextSummary:
            "Contexto inicial · {count} documento(s) · comentários {commentsStatus}",
        p0CommentsSaved: "salvos",
        p0CommentsUnsaved: "não salvos",
        p0ApproveStep: "Etapa final",
        p0ApproveAndAdvance: "Aprovar e avançar",
        dashboardTitle: "Painel LAURA",
        statActive: "Auditorias ativas",
        statInProgress: "Planejamento em andamento",
        statPlanningDone: "Planejamento concluído",
        statPending: "Em fase de planejamento",
        planningProgress: "Progresso do planejamento",
        planningProgressStep: "Etapa {current} de {total}",
        tabInputs: "Entradas",
        tabValidation: "Validação",
        validationPending: "QA humano pendente",
        validationHint: "Confirme cada ponto antes de aprovar esta etapa.",
        validationEmpty: "Nenhum ponto de validação ainda",
        validationGenerateHint: "Gere o entregável com IA para popular os pontos de validação.",
        createSampleAudit: "Criar auditoria exemplo NHAI",
        seedingAudit: "Carregando dados de exemplo…",
        lastUpdated: "Última atualização",
        saveForm: "Salvar formulário",
        saveDeliverable: "Salvar entregável",
        deliverable: "Entregável",
        validationTitle: "Pontos de validação",
        p1Title: "P1 — Canvas de Auditoria",
        p2Title: "P2 — Visão Geral do Objeto",
        p3Title: "P3 — Matriz de Riscos",
        p4Title: "P4 — Matriz de Planejamento",
        p5Title: "P5 — Instrumentos de Coleta",
        p6Title: "P6 — Plano de Auditoria",
        p7Title: "P7 — Supervisão e Qualidade",
        generateCanvas: "Gerar canvas",
        generateOverview: "Gerar visão geral",
        generateRisks: "Gerar matriz de riscos",
        generateMatrix: "Gerar matriz de planejamento",
        generateInstruments: "Gerar instrumentos",
        generatePlan: "Gerar plano de auditoria",
        generateQuality: "Gerar revisão de qualidade",
        addRisk: "Adicionar risco",
        mandatoryGate: "Portão obrigatório — aprovação do supervisor antes de E0",
        executiveSummary: "Sumário executivo",
        financialBenefits: "Benefícios financeiros",
        nonFinancialBenefits: "Benefícios não financeiros",
        p1_subject: "Objeto",
        p1_criteria: "Critérios",
        p1_evidence: "Estratégia de evidências",
        p1_problem: "Problema de auditoria",
        p1_stakeholders: "Stakeholders",
        p1_assurance: "Nível de asseguração",
        p1_objective: "Objetivo SMART",
        p1_outOfScope: "Não escopo",
        p1_scope: "Escopo",
        p1_engRisks: "Riscos do engajamento",
        p1_deliverables: "Entregáveis",
        p1_timeline: "Cronograma",
        p1_benefits: "Benefícios esperados",
        p2_mandate: "Propósito e base legal",
        p2_financialChart: "Tendência financeira",
        p2_swot: "Análise SWOT",
        p2_org: "Estrutura organizacional",
        p2_process: "Mapa de processos",
    },
} satisfies TranslationDictionary;
